import React from 'react';
import { isNullOrUndefined } from 'utils/Global';
import './MarcoSidebarButtons.scss';

const MarcoSidebarButtons = ({ height, width, buttons }: any) => {
  const actionBtns = [];
  let btnview;
  if (buttons) {
    for (let i = 0; i < buttons.length; i += 1) {
      const button = buttons[i];
      if (isNullOrUndefined(button)) {
        continue;
      }

      btnview = (
        <div
          id={`marco-sidebar-button-${i}-container`}
          key={`marcoButtons-${i}`}
          className={
            button.isDisabled
              ? 'marco-main-container-disabled'
              : button.showActive
              ? 'marco-main-container-active enabledDiv'
              : 'marco-main-container enabledDiv'
          }
          onClick={button.isDisabled ? null : button.onClick}
        >
          <div id={`marco-sidebar-button-${i}-icon-title-row`} className="icon-title-row">
            <div id={`marco-sidebar-button-${i}-title`} className="title-container-marco">{button.title}</div>
            <div id={`marco-sidebar-button-${i}-icon`} className="icon-style">{button.Icon}</div>
          </div>
          <div id={`marco-sidebar-button-${i}-message`} className="message-container">{button.message}</div>
        </div>
      );

      actionBtns.push(btnview);
    }
  }
  return (
    <div
      id='marco-sidebarbutton-container'
      className="flex-y-center flex-column"
      style={{
        height: height,
        width: width,
        paddingLeft: '1%',
        paddingRight: '1%',
      }}
    >
      {actionBtns}
    </div>
  );
};

export default MarcoSidebarButtons;
